import React from 'react';
import { Container, Card, CardBody, Button, Row, Col, Label, Input, Badge } from 'reactstrap';
// Round DMS-UAT-5 (2026) — Description of Change / Reasons for Change /
// Instructions are stored as HTML (legacy RichTextBox content converted by
// RtfHelper, and everything the modern form saved through these fields).
// They were bound to PLAIN textareas, so the editor displayed the raw
// markup ("<div style=...><p ...>") the user circled. They are now
// ReactQuill rich-text editors — the same editor CreateEcn already uses
// for Purpose/Scope — so the stored HTML renders as formatted text and
// saves back as HTML, which the preview modal and the PDF already render
// correctly (dangerouslySetInnerHTML / FormatRichText).
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// Round DMS-UAT-1 (2026) — Issue 9: options now come from the shared
// constants module. Adds "ECR/CR Change Request" and fixes the
// "Use to Deplation" typo (legacy values are normalized on load in
// CreateEcn.js so old documents still show their saved checks).
import ECN_WILL_CHANGE_OPTIONS from '../../constants/ecnWillChangeOptions';

// Compact toolbar — matches the CreateEcn Purpose/Scope editors minus the
// heading levels (these fields are body text on the printed ECN).
const detailsQuillModules = {
    toolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["clean"],
    ],
};
const detailsQuillFormats = [
    "bold", "italic", "underline", "strike",
    "list", "bullet", "indent", "align",
];

// NOTE: Quill represents "empty" as "<p><br></p>". Normalizing that back
// to "" happens in CreateEcn.buildPayload (not here in onChange) so the
// controlled value handed back to Quill always matches what it emitted —
// avoids a cursor-reset loop while typing.

const EcnDetailsTab = ({ data, update }) => {

    const ecnChangeOptions = ECN_WILL_CHANGE_OPTIONS;

    const toggleChange = (option) => {
        const current = data.ecnWillChange || [];

        let updated;

        if (current.includes(option)) {
            updated = current.filter(o => o !== option);

            // If removing "Other", also clear text
            if (option === "Other") {
                update("otherChangeText", "");
            }
        } else {
            updated = [...current, option];
        }

        update("ecnWillChange", updated);
    };
    return (
        <>
            <Row className="mb-3">
                <Col md={12}>
                    <Label>Description of Change</Label>
                    <ReactQuill
                        theme="snow"
                        modules={detailsQuillModules}
                        formats={detailsQuillFormats}
                        value={data.descriptionOfChange || ""}
                        onChange={(html) =>
                            update("descriptionOfChange", html)
                        }
                        style={{ backgroundColor: "#fff" }}
                    />
                </Col>
            </Row>

            <Row className="mb-3">
                <Col md={12}>
                    <Label>Reasons for Change</Label>
                    <ReactQuill
                        theme="snow"
                        modules={detailsQuillModules}
                        formats={detailsQuillFormats}
                        value={data.reasonsForChange || ""}
                        onChange={(html) =>
                            update("reasonsForChange", html)
                        }
                        style={{ backgroundColor: "#fff" }}
                    />
                </Col>
            </Row>

            <Row>
                {ecnChangeOptions.map(opt => {
                    const isChecked = (data.ecnWillChange || []).includes(opt);

                    return (
                        <Col md={3} key={opt} className="mb-2">
                            <div className="form-check">
                                <Input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => toggleChange(opt)}
                                />
                                <Label className="form-check-label">
                                    {opt}
                                </Label>
                            </div>

                            {/* 👇 If "Other" is checked, show textbox */}
                            {opt === "Other" && isChecked && (
                                <Input
                                    type="text"
                                    className="mt-2"
                                    placeholder="Please specify..."
                                    value={data.otherChangeText || ""}
                                    onChange={(e) =>
                                        update("otherChangeText", e.target.value)
                                    }
                                />
                            )}
                        </Col>
                    );
                })}
            </Row>
            <Row className="mb-3">
                <Col md={12}>
                    <Label>Instructions for ECN Implementation</Label>
                    <ReactQuill
                        theme="snow"
                        modules={detailsQuillModules}
                        formats={detailsQuillFormats}
                        value={data.implementationDateInstructions || ""}
                        onChange={(html) =>
                            update("implementationDateInstructions", html)
                        }
                        style={{ backgroundColor: "#fff" }}
                    />
                </Col>
            </Row>
        </>
    );
};

export default EcnDetailsTab;